/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Test_Not_ConfiguredInputs */

const th_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ระบบนี้ยังไม่ได้ตั้งค่าคีย์สำหรับการแจ้งเตือน จึงส่งไม่ได้ นี่เป็นการตั้งค่าฝั่งเซิร์ฟเวอร์ ไม่ใช่สิ่งที่คุณแก้ได้จากหน้านี้`)
};

const en_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This deployment has no push keys, so nothing could be sent. That is a server setting, not something you can fix here.`)
};

const ja_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この環境にはプッシュ用の鍵が設定されていないため、送信できませんでした。サーバー側の設定で、ここからは変更できません。`)
};

const zh_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此安装没有推送密钥，因此什么都没发出去。这是服务器设置，不是你在这里能修复的。`)
};

const es_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta instalación no tiene claves push, así que no se pudo enviar nada. Es un ajuste del servidor, no algo que puedas arreglar aquí.`)
};

const pt_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta instalação não tem chaves push, então nada pôde ser enviado. É uma configuração do servidor, não algo que você resolva aqui.`)
};

const id_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemasangan ini tidak punya kunci push, jadi tidak ada yang bisa dikirim. Itu pengaturan server, bukan sesuatu yang bisa Anda perbaiki di sini.`)
};

const fr_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce déploiement n’a pas de clés push, rien n’a donc pu être envoyé. C’est un réglage serveur, pas quelque chose que vous pouvez corriger ici.`)
};

const tl_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang push key ang instalasyong ito, kaya walang naipadala. Setting iyon ng server, hindi bagay na maaayos mo rito.`)
};

const vi_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản cài này không có khoá đẩy, nên không gửi được gì. Đó là thiết lập máy chủ, không phải thứ bạn sửa được ở đây.`)
};

const ko_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 설치본에는 푸시 키가 없어 아무것도 보내지 못했습니다. 서버 설정이며 여기서 고칠 수 있는 것이 아닙니다.`)
};

const de_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Installation hat keine Push-Schlüssel, es konnte also nichts gesendet werden. Das ist eine Servereinstellung, nichts, was du hier beheben kannst.`)
};

const ru_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У этой установки нет push-ключей, поэтому ничего не отправлено. Это настройка сервера, а не то, что можно исправить здесь.`)
};

const tr_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu kurulumun anlık bildirim anahtarları yok, bu yüzden hiçbir şey gönderilmedi. Bu bir sunucu ayarı, burada düzeltebileceğiniz bir şey değil.`)
};

const it_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa installazione non ha chiavi push, quindi non è stato inviato nulla. È un'impostazione del server, non qualcosa che puoi risolvere qui.`)
};

const pl_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta instalacja nie ma kluczy push, więc nic nie wysłano. To ustawienie serwera, a nie coś, co możesz tu naprawić.`)
};

const uk_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У цієї інсталяції немає push-ключів, тож нічого не надіслано. Це налаштування сервера, а не те, що можна виправити тут.`)
};

const hi_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस इंस्टॉलेशन के पास पुश कुंजियाँ नहीं हैं, इसलिए कुछ नहीं भेजा गया। यह सर्वर की सेटिंग है, ऐसा कुछ नहीं जिसे आप यहाँ ठीक कर सकें।`)
};

const ar_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا تملك هذه النسخة مفاتيح الإشعارات، فلم يُرسل شيء. هذا إعداد على الخادم، لا شيء يمكنك إصلاحه هنا.`)
};

const ms_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemasangan ini tiada kunci tolakan, jadi tiada apa dihantar. Itu tetapan pelayan, bukan sesuatu yang anda boleh betulkan di sini.`)
};

const bn_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই ইনস্টলেশনের পুশ কি নেই, তাই কিছুই পাঠানো হয়নি। এটি সার্ভারের সেটিং, এখানে ঠিক করার মতো কিছু নয়।`)
};

const zh_tw2_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個安裝沒有推播金鑰，因此什麼都沒送出。這是伺服器設定，不是你在這裡能修正的。`)
};

const zh_hk2_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個安裝沒有推播金鑰，因此什麼都沒送出。這是伺服器設定，不是你在這裡能修正的。`)
};

const ur_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس تنصیب کے پاس پُش کی چابیاں نہیں، اس لیے کچھ نہیں بھیجا گیا۔ یہ سرور کی ترتیب ہے، ایسی چیز نہیں جو آپ یہاں ٹھیک کر سکیں۔`)
};

const fa_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این نصب کلید اعلان ندارد، پس چیزی فرستاده نشد. این تنظیم سرور است، نه چیزی که اینجا درستش کنید.`)
};

const sw_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usakinishaji huu hauna funguo za arifa, kwa hivyo hakuna kilichotumwa. Hiyo ni mipangilio ya seva, si kitu unachoweza kukirekebisha hapa.`)
};

const nl_test_not_configured = /** @type {(inputs: Test_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze installatie heeft geen pushsleutels, dus er is niets verstuurd. Dat is een serverinstelling, niet iets wat je hier kunt oplossen.`)
};

/**
* | output |
* | --- |
* | "This deployment has no push keys, so nothing could be sent. That is a server setting, not something you can fix here." |
*
* @param {Test_Not_ConfiguredInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const test_not_configured = /** @type {((inputs?: Test_Not_ConfiguredInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Test_Not_ConfiguredInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_test_not_configured(inputs)
	if (locale === "ja") return ja_test_not_configured(inputs)
	if (locale === "zh") return zh_test_not_configured(inputs)
	if (locale === "es") return es_test_not_configured(inputs)
	if (locale === "pt") return pt_test_not_configured(inputs)
	if (locale === "id") return id_test_not_configured(inputs)
	if (locale === "fr") return fr_test_not_configured(inputs)
	if (locale === "tl") return tl_test_not_configured(inputs)
	if (locale === "vi") return vi_test_not_configured(inputs)
	if (locale === "ko") return ko_test_not_configured(inputs)
	if (locale === "de") return de_test_not_configured(inputs)
	if (locale === "ru") return ru_test_not_configured(inputs)
	if (locale === "tr") return tr_test_not_configured(inputs)
	if (locale === "it") return it_test_not_configured(inputs)
	if (locale === "pl") return pl_test_not_configured(inputs)
	if (locale === "uk") return uk_test_not_configured(inputs)
	if (locale === "hi") return hi_test_not_configured(inputs)
	if (locale === "ar") return ar_test_not_configured(inputs)
	if (locale === "ms") return ms_test_not_configured(inputs)
	if (locale === "bn") return bn_test_not_configured(inputs)
	if (locale === "zh-TW") return zh_tw2_test_not_configured(inputs)
	if (locale === "zh-HK") return zh_hk2_test_not_configured(inputs)
	if (locale === "ur") return ur_test_not_configured(inputs)
	if (locale === "fa") return fa_test_not_configured(inputs)
	if (locale === "sw") return sw_test_not_configured(inputs)
	if (locale === "nl") return nl_test_not_configured(inputs)
	return en_test_not_configured(inputs)
});